import React from 'react';
import styled from '@emotion/styled';

type FrameProps = {
    size: number;
}

const Frame = styled.div<FrameProps>(props => ({
    position: 'relative',
    height: `${props.size * 2}px`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
}));

const Lane = styled.div({
    height: '20px',
    width: '100%',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, .1)',
});

type CircleProps = {
    size: number;
}

const Circle = styled.div<CircleProps>(props => ({
    position: 'absolute',
    left: 0,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: `${props.size}px`,
    borderColor: '#00a3e0',
    boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, .15)',
    transform: 'translateX(-50%)',
}));

type SliderProps = {
    ratio: number;
    speed?: number;
}

const Slider = styled.div<SliderProps>(props => ({
    position: 'absolute',
    left: 0,
    width: '100%',
    height: '100%',
    transform: `translateX(${props.ratio * 100}%)`,
    transition: props.speed === undefined ? undefined : `transform ${props.speed}s`,
}));

export type SliderBarProps = {
    className?: string;
    ratio: number;
    speed?: number;
    size?: number;
}

export const SliderBar = (props: SliderBarProps) => {
    const size = props.size || 14;

    return (
        <Frame className={props.className} size={size}>
            <Lane>
            </Lane>
            <Slider ratio={props.ratio} speed={props.speed}>
                <Circle size={size} />
            </Slider>
        </Frame>
    );
};
